<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ContractDeliveryOrderForm from './DeliveryOrder/ContractDeliveryOrderForm.vue'
import ContractDeliveryOrderList from './DeliveryOrder/ContractDeliveryOrderList.vue'
import ContractSingleDeliveryOrder from './DeliveryOrder/ContractSingleDeliveryOrder.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'

export default {
  components: {
    ButtonAll,
    ContractSingleDeliveryOrder,
    ContractDeliveryOrderList,
    ContractDeliveryOrderForm,
    BlockContent,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: String, required: true },
    defContract: { type: Object, required: true },
    uuid: { type: String, required: false },
  },

  data() {
    return {
      deliveryOrders: [],
      deliveryOrderId: null,
      def: {},
      loading: false,
      isNew: true,
      isReload: false,
      isOnly: false,
      isAddPossible: false,
      hideDelivery: false,
    }
  },

  methods: {
    freeUrl(url) {
      if (!this.uuid) {
        return url
      }

      const separator = url.includes('?') ? '&' : '?'
      return `free/${url}${separator}uniqid=${this.uuid}`
    },
    addView: function () {
      this.deliveryOrderId = null
      this.isNew = true
      this.isReload = false
    },
    listView: function () {
      this.isNew = false
      this.isReload = false
    },
    reloadDelivery: function (id) {
      this.deliveryOrderId = id
      this.isNew = false
      this.isReload = true
    },
  },

  beforeMount() {
    this.loading = true
    this.getJSON(this.freeUrl(`deliveryorders?contractId=${this.contractId}`)).then((json) => {
      this.contract = json.contract
      this.loading = false

      this.isAddPossible = Object.keys(json.deliveryOrders).length === 0

      const equipmentsFromDeliveryOrders = json.deliveryOrders.flatMap((d) => d.equipments.map((e) => e.id))

      if (
        equipmentsFromDeliveryOrders.length > 0 &&
        this.contract &&
        this.contract.finance &&
        this.contract.finance.equipment
      ) {
        const equipmentsFromContract = []
        const { id: contractEquipmentId, equipments } = this.contract.finance.equipment
        equipmentsFromContract.push(contractEquipmentId)
        equipmentsFromContract.push(...equipments.map((e) => e.id))

        const hasAllEquipments = equipmentsFromContract.every((eq) => equipmentsFromDeliveryOrders.includes(eq))
        if (!hasAllEquipments) {
          this.isAddPossible = true
        }
      }

      if (this.contract.finance?.equipment?.equipments?.length === 0) {
        this.isOnly = true
        if (json.deliveryOrders.length !== 0) {
          this.deliveryOrderId = json.deliveryOrders[0].id
        }
      } else {
        if (json.deliveryOrders.length !== 0) {
          this.deliveryOrders = json.deliveryOrders
          this.isNew = false
        } else {
          this.addView()
        }
      }
    })
  },
}
</script>
<template>
  <div>
    <BlockContent>
      <template v-if="!loading">
        <div v-if="(isNew || isReload) && !isOnly">
          <div v-if="deliveryOrders.length > 0" class="d-flex justify-content-between align-items-center">
            <h4>{{ $t('equipment.title') }}</h4>
            <ButtonAll
              type="info"
              label="delivery.listView"
              name="seeDeliveryOrder"
              e2e-button="seeDeliveryOrder"
              @click="listView"
            />
          </div>
          <ContractDeliveryOrderForm
            :contract-id="Number(contractId)"
            :delivery-order-id="deliveryOrderId"
            :esign-contract="contract.esign"
            :new="isNew"
            :reload="isReload"
            :uuid="uuid"
          />
        </div>
        <div v-else-if="(!isNew || !isReload) && !isOnly">
          <h4 v-html="$t('delivery.mainTitle')"></h4>
          <ContractDeliveryOrderList
            :delivery-orders="deliveryOrders"
            :contract-number="contract.number"
            :contract-id="Number(contractId)"
            :uuid="uuid"
            @reload-delivery="reloadDelivery"
          />
          <button v-if="isAddPossible" type="button" class="btn btn-info" @click="addView" e2e-button="backToEquipment">
            {{ $t('delivery.addView') }}
          </button>
        </div>
        <div v-else-if="isOnly">
          <ContractSingleDeliveryOrder
            id="delivery-single"
            :contract-id="contractId"
            :delivery-order-id="deliveryOrderId"
            :contract-number="contract.number"
            :uuid="uuid"
          />
        </div>
      </template>
      <template v-else>
        <div class="row justify-content-center">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </template>
    </BlockContent>
  </div>
</template>
